import React, { useCallback, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import ProjectPage from './pages/ProjectPage';
import MentionsLegales from './pages/MentionsLegales';
import PolitiqueConfidentialite from './pages/PolitiqueConfidentialite';
import PolitiqueCookies from './pages/PolitiqueCookies';
import CGU from './pages/CGU';
import CGV from './pages/CGV';
import SiteNav from './components/SiteNav';
import SiteFooter from './components/SiteFooter';
import Cursor from './components/motion/Cursor';
import { useScrollProgress } from './hooks/useScroll';
import { Toaster } from './components/ui/toaster';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';

function ReadingProgress() {
  const [progress, setProgress] = useState(0);
  useScrollProgress(useCallback((v) => setProgress(v), []));
  return <span className="scroll-progress" style={{ '--progress': progress }} />;
}

function App() {
  return (
    <BrowserRouter>
      <Cursor />
      <ReadingProgress />
      <span className="grain" aria-hidden="true" />
      <SiteNav />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projets/:slug" element={<ProjectPage />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-de-confidentialite" element={<PolitiqueConfidentialite />} />
        <Route path="/politique-cookies" element={<PolitiqueCookies />} />
        <Route path="/cgu" element={<CGU />} />
        <Route path="/cgv" element={<CGV />} />
      </Routes>

      <SiteFooter />
      <Toaster />
      <SpeedInsights />
      <Analytics />
    </BrowserRouter>
  );
}

export default App;
